class Looper {
	constructor(context) {
		this.context = context;
		this.input = this.context.createGain();
		this.delayGain = this.context.createGain();
		this.delay = this.context.createDelay(40);
		this.feedbackGain = this.context.createGain();
		this.outputGain = this.context.createGain();

		this.input.gain.setValueAtTime(0, this.context.currentTime);

		this.input.connect(this.delay);
		this.input.connect(this.outputGain);
		this.delay.connect(this.feedbackGain);
		this.feedbackGain.connect(this.delay);
		this.delay.connect(this.delayGain);
		this.delayGain.connect(this.outputGain);
		this.outputGain.gain.setValueAtTime(0, this.context.currentTime);

		this.state = 'CLEAR';
	}

	connect(output) {
		this.outputGain.connect(output);
	}

	disconnect(output) {
		this.outputGain.disconnect();
	}

	startRec() {
		if (this.state !== 'CLEAR') {
			return;
		} else {
			this.outputGain.gain.setValueAtTime(0, this.context.currentTime);
			this.input.gain.linearRampToValueAtTime(1, this.context.currentTime+0.2);
			this.startTime = this.context.currentTime;
			this.feedbackGain.gain.linearRampToValueAtTime(1, this.context.currentTime+0.02);
			this.delay.delayTime.setValueAtTime(40, this.context.currentTime);
			return (this.state = 'REC');
		}
	}

	stopRec() {
		if (this.state === 'REC') {
			this.delay.delayTime.setValueAtTime(this.context.currentTime - this.startTime, this.context.currentTime);
			this.outputGain.gain.setValueAtTime(1, this.context.currentTime);
			this.input.gain.linearRampToValueAtTime(0, this.context.currentTime+0.4);

			return (this.state = 'PLAYING');
		} else {
			return;
		}
	}

	flush() {
		this.input.gain.setValueAtTime(0, this.context.currentTime);
		this.outputGain.gain.setValueAtTime(0, this.context.currentTime);
		this.feedbackGain.gain.setValueAtTime(0, this.context.currentTime+0.01);
		this.delay.delayTime.setValueAtTime(0, this.context.currentTime);

		this.input.disconnect(this.delay);
		this.delay.disconnect(this.feedbackGain);
		this.feedbackGain.disconnect(this.delay);
		this.delay.disconnect(this.delayGain);

		this.delay = this.context.createDelay(40);
		this.input.connect(this.delay);
		this.delay.connect(this.feedbackGain);
		this.feedbackGain.connect(this.delay);
		this.delay.connect(this.delayGain);

		return (this.state = 'CLEAR');
	}

	resetDelay() {}

	setParam = (key, value) => {
		if (key === 'MIX') {
			this.delayGain.gain.setValueAtTime(value, this.context.currentTime);
			return;
		}
		if (key == 'FDBK') {
			this.feedbackGain.gain.setValueAtTime(value, this.context.currentTime);
			return;
		}
		if (key == 'TIME') {
			this.delay.delayTime.setValueAtTime(value, this.context.currentTime);
			return;
		}

		throw new Error(`unkown parameter ${key}`);
	};
}

export default Looper;
